export default class DateUtils {
  static adjustTimezone(myDate: Date, myTimezone: number): Date {
    const offset = isNaN(myTimezone) ? new Date().getTimezoneOffset() : myTimezone * 60;
    return new Date(myDate.getTime() + offset * 60 * 1000);
  }

  static parseIntStrict(num: number | null): number | null {
    return num;
  }

  static getMaxDate(month: number | null, year: number | null): number {
    let res = 31;
    if (month != null) {
      if (month === 4 || month === 6 || month === 9 || month === 11) {
        res = 30;
      }
      if (month === 2) {
        res = 28;
        if (year !== null) {
          res = year % 4 === 0 ? 29 : 28;
        }
      }
    }
    return res;
  }

  // Normalizes various date input formats (Date objects, timestamps, ISO strings) from external sources like APIs or user input
  // into a standardized Date object with timezone adjustment, ensuring consistent date handling throughout the date picker component
  static parseDate(myDate: Date | number | string | null | undefined, myTimezone: number): Date | null {
    let res: Date | null = null;
    if (myDate !== undefined && myDate !== null) {
      if (myDate instanceof Date) {
        res = myDate;
      } else {
        if (typeof myDate === 'number' || typeof myDate === 'string') {
          if (typeof myDate === 'number') {
            res = new Date(parseInt(myDate.toString(), 10));
          } else {
            res = new Date(myDate);
          }
          res = DateUtils.adjustTimezone(res, myTimezone);
        }
      }
    }
    return res;
  }
}
